import { ClientError } from '@tribeplatform/gql-client/lib'
import {
  Chat,
  MutationCreateGroupChatArgs,
} from '@tribeplatform/gql-client/types'

import {
  UseMutationOptions,
  useMutation,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getHasChatsKey } from '../../utils/keys/messaging.key.js'

export const useCreateGroupChat = (
  options?: UseMutationOptions<Chat, ClientError, MutationCreateGroupChatArgs>,
) => {
  const { client } = useTribeClient()
  const queryClient = useQueryClient()
  const hasChatsKey = getHasChatsKey()

  return useMutation<Chat, ClientError, MutationCreateGroupChatArgs>(
    (input: MutationCreateGroupChatArgs) =>
      client.messaging.createGroupChat(input),
    {
      ...(options ?? {}),
      onSuccess: _ => {
        const hasChats = queryClient.getQueryData<boolean>(hasChatsKey)
        if (!hasChats) {
          queryClient.setQueryData(hasChatsKey, true)
        }
      },
    },
  )
}
